import { Component, Inject } from '@angular/core';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-control-pass',
  imports: [ModalComponent],
  templateUrl: './dialog-control-pass.component.html',
  styleUrl: './dialog-control-pass.component.scss',
})
export class DialogControlPassComponent {
  senhaGerada: string;

  constructor(
    public dialogRef: MatDialogRef<DialogControlPassComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.senhaGerada = data.senha;
  }

  close() {
    this.dialogRef.close();
  }
}
